// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popper[data-v-e586a2e0]  li:hover{color:#006dcc;cursor:pointer;background:#f3f2f2}", ""]);
// Exports
module.exports = exports;
